import { render, staticRenderFns } from "./MedicationPlanEdit.vue?vue&type=template&id=5a39a8ad&scoped=true&"
import script from "./MedicationPlanEdit.vue?vue&type=script&lang=js&"
export * from "./MedicationPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39a8ad",
  null
  
)

export default component.exports